import React from 'react';

import favesBird from '../../components/brand/faves-bird.svg';
import { IdentityDrawer } from '../../components/IdentityDrawer/IdentityDrawer';
import { SportIcon } from '../../components/SportIcon/SportIcon';
import type { Athlete } from './athletes';

function renderSportIcon(athlete: Athlete) {
    return athlete.sportIconUrl
        ? <img src={athlete.sportIconUrl} alt="" loading="lazy" decoding="async" />
        : <SportIcon iconKey={athlete.sportIcon} />;
}

type MobileAthleteDrawerProps = {
    athletes: Athlete[];
    selectedAthlete: Athlete;
    isOpen: boolean;
    onToggle: () => void;
    onClose: () => void;
    onSelect: (id: string, index: number) => void;
};

export function MobileAthleteDrawer({ athletes, selectedAthlete, isOpen, onToggle, onClose, onSelect }: MobileAthleteDrawerProps) {
    const items = athletes.map((athlete) => ({
        id: athlete.id,
        label: athlete.name,
        meta: (
            <>
                {athlete.isFavesAthlete && <img src={favesBird} alt="" aria-hidden="true" />}
                <span className="athlete-carousel__mobile-sport athlete-carousel__mobile-sport--list" aria-hidden="true">
                    {renderSportIcon(athlete)}
                </span>
            </>
        ),
    }));

    const selectedItem = items.find((item) => item.id === selectedAthlete.id) ?? items[0];

    return (
        <IdentityDrawer
            items={items}
            selectedItem={selectedItem}
            isOpen={isOpen}
            onToggle={onToggle}
            onClose={onClose}
            onSelect={onSelect}
            ariaLabel={`${selectedAthlete.name} athlete list`}
            className="athlete-carousel__mobile-drawer"
            renderSelectedMeta={() => (
                <span className="athlete-carousel__mobile-sport" aria-hidden="true">
                    {renderSportIcon(selectedAthlete)}
                </span>
            )}
        />
    );
}
